import { redirectToUrl } from "~/utils/url/urlUtils";
import { resolveUrl } from "~/utils/url/urlResolver";
import { createDesignationSearchRedirectUrl } from "~/features/search/utils/searchNavigationUrls";

export const REDIRECT_TO_PRODUCT = "productCodeOrDesign";

let redirectSuggestUserSwitch = false;
let redirectProduct = "";

export function setRedirectState(switchUser: boolean, product: string) {
  redirectSuggestUserSwitch = switchUser;
  redirectProduct = product;
}

export function getSuggestUserSwitch(): boolean {
  return redirectSuggestUserSwitch;
}

export function getRedirectProduct(): string {
  return redirectProduct;
}

export const setUpLoginPopUp = () => {
  if (redirectProduct) {
    window.sessionStorage.setItem(REDIRECT_TO_PRODUCT, redirectProduct);
  }
};
export const clearRedirectionInfo = () => {
  window.sessionStorage.setItem(REDIRECT_TO_PRODUCT, "");
  redirectSuggestUserSwitch = false;
  redirectProduct = "";
};
export const toBeRedirectedToPdp: () => boolean = () => {
  return !!window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
};
export const redirectToPdp = () => {
  const productCodeOrDesignation = window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
  clearRedirectionInfo();
  redirectToUrl(resolveUrl(`/p/${productCodeOrDesignation}`));
};

export const redirectToSrp = () => {
  const productCodeOrDesignation = window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
  clearRedirectionInfo();
  redirectToUrl(createDesignationSearchRedirectUrl(productCodeOrDesignation ?? "", true));
};
